import { endApiLoader, startApiLoader } from './apiLoaderService'
import urlConstant from '../constants/urlConstant'
import dataConstant from '../constants/dataConstants'
import { getTokenRedirect, signOut, tokenRequest } from '../config/authRedirect'

const CryptoJS = require('crypto-js')

class CommonService {
  httpGet = async (requestURL, authorizationRequired, enableLoader = true) =>
    new Promise((resolve, reject) => {
      const options = {
        method: 'get',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
        },
      }

      if (enableLoader) {
        startApiLoader()
      }
      getTokenRedirect(tokenRequest).then(tokenResponse => {
        try {
          if (authorizationRequired && tokenResponse) {
            options.headers.Authorization = `bearer ${tokenResponse.accessToken}`
          }
          fetch(requestURL, options)
            .then(
              response => {
                if (response.status === 404 || response.status === 400 || response.status === 500) {
                  this.AddErrorLog(response.status, response.url)
                }
                if (response.status === 404 || response.status === 200 || response.status === 400) {
                  return response.json()
                }
                return response
              },
              err => {
                reject(err)
              },
            )
            .then(
              responseJson => {
                if (responseJson.status === 401) {
                  console.warn('UnAuthorize')
                }
                resolve(responseJson)
              },
              err => {
                this.AddErrorLog(err.message, err.stack)
                reject(err)
              },
            )
            .catch(err => {
              this.AddErrorLog(err.message, err.stack)
              reject(err)
            })
            .finally(() => {
              if (enableLoader) {
                endApiLoader()
              }
            })
        } catch (error) {
          console.warn(error)
        }
      })
    })

  httpPost = async (requestURL, requestBody, authorizationRequired, enableLoader = true) =>
    new Promise((resolve, reject) => {
      const options = {
        method: 'post',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify(requestBody),
      }

      if (enableLoader) {
        startApiLoader()
      }
      getTokenRedirect(tokenRequest).then(tokenResponse => {
        try {
          if (authorizationRequired && tokenResponse) {
            options.headers.Authorization = `bearer ${tokenResponse.accessToken}`
          }
          fetch(requestURL, options)
            .then(
              response => {
                if (response.status === 404 || response.status === 400 || response.status === 500) {
                  this.AddErrorLog(response.status, response.url)
                }
                if (response.status === 404 || response.status === 200 || response.status === 400) {
                  return response.json()
                }
                return response
              },
              err => {
                reject(err)
              },
            )
            .then(
              responseJson => {
                if (responseJson.status === 401) {
                  signOut()
                }
                resolve(responseJson)
              },
              err => {
                this.AddErrorLog(err.message, err.stack)
                reject(err)
              },
            )
            .catch(err => {
              this.AddErrorLog(err.message, err.stack)
              reject(err)
            })
            .finally(() => {
              if (enableLoader) {
                endApiLoader()
              }
            })
        } catch (error) {
          console.warn(error)
        }
      })
    })

  DocumentUpload = async (requestURL, formData, authorizationRequired, enableLoader = true) =>
    new Promise((resolve, reject) => {
      const options = {
        method: 'post',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      }

      if (enableLoader) {
        startApiLoader()
      }
      getTokenRedirect(tokenRequest).then(tokenResponse => {
        try {
          if (authorizationRequired && tokenResponse) {
            options.headers.Authorization = `bearer ${tokenResponse.accessToken}`
          }
          fetch(requestURL, options)
            .then(
              response => {
                if (response.status === 404 || response.status === 400 || response.status === 500) {
                  this.AddErrorLog(response.status, response.url)
                }
                if (response.status === 404 || response.status === 200 || response.status === 400) {
                  return response.json()
                }
                return response
              },
              err => {
                reject(err)
              },
            )
            .then(
              responseJson => {
                if (responseJson.status === 401) {
                  signOut()
                }
                resolve(responseJson)
              },
              err => {
                this.AddErrorLog(err.message, err.stack)
                reject(err)
              },
            )
            .catch(err => {
              this.AddErrorLog(err.message, err.stack)
              reject(err)
            })
            .finally(() => {
              if (enableLoader) {
                endApiLoader()
              }
            })
        } catch (error) {
          console.warn(error)
        }
      })
    })

  httpGetFlagImage = async (requestURL, authorizationRequired, enableLoader = true) =>
    new Promise((resolve, reject) => {
      const options = {
        responseType: 'blob',
        method: 'get',
        headers: {
          'content-type': 'application/json;',
        },
      }

      if (enableLoader) {
        startApiLoader()
      }
      getTokenRedirect(tokenRequest).then(tokenResponse => {
        try {
          if (authorizationRequired && tokenResponse) {
            options.headers.Authorization = `bearer ${tokenResponse.accessToken}`
          }
          fetch(requestURL, options)
            .then(
              response => {
                if (response.status === 404 || response.status === 400 || response.status === 500) {
                  this.AddErrorLog(response.status, response.url)
                }
                if (response.status === 404 || response.status === 200 || response.status === 400) {
                  return response
                }
                return response
              },
              err => {
                reject(err)
              },
            )
            .then(
              responseJson => {
                if (responseJson.status === 401) {
                  signOut()
                }
                resolve(responseJson)
              },
              err => {
                this.AddErrorLog(err.message, err.stack)
                reject(err)
              },
            )
            .catch(err => {
              this.AddErrorLog(err.message, err.stack)
              reject(err)
            })
            .finally(() => {
              if (enableLoader) {
                endApiLoader()
              }
            })
        } catch (error) {
          console.warn(error)
        }
      })
    })

  AddErrorLog = (message, stack) => {
    const ErrorData = {
      Message: message,
      Stack: stack,
      ErrorFrom: dataConstant.SiteName,
    }
    const options = {
      method: 'post',
      headers: {
        'content-type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify(ErrorData),
    }
    getTokenRedirect(tokenRequest).then(tokenResponse => {
      try {
        if (tokenResponse) {
          options.headers.Authorization = `bearer ${tokenResponse.accessToken}`
        }
        fetch(urlConstant.ErrorLog.AddErrorLog, options)
          .then(
            response => {
              console.error(response)
            },
            err => {
              console.error(err)
            },
          )
          .catch(err => {
            console.error(err)
          })
      } catch (error) {
        console.warn(error)
      }
    })
  }

  DecryptData = data => {
    const key = CryptoJS.enc.Utf8.parse(dataConstant.AESEncryptDecryptKey)
    const iv = CryptoJS.enc.Utf8.parse(dataConstant.AESEncryptDecryptKey)
    const decrypted = CryptoJS.AES.decrypt(data, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
  }

  encryptData = data => {
    const key = CryptoJS.enc.Utf8.parse(dataConstant.AESEncryptDecryptKey)
    const iv = CryptoJS.enc.Utf8.parse(dataConstant.AESEncryptDecryptKey)

    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })
    return encrypted.toString()
  }

  isValidZipCode = (str) => {
    return /^[a-zA-Z0-9]{1,25}$/.test(str);
  }

}
export default CommonService
